

function LogoutComponent() {
    return (
        <div className="LogoutComponent">
            <h1>You are logged Out!</h1>
            <div>
                Thank you for using our app. Come Back soon!
            </div>
        </div>
    )
}

export default LogoutComponent;